import { memo, ReactNode } from 'react';
import { I18n } from 'src/modules/common/components/I18n/I18n.tsx';

type Props = {
    title: string;
    children: ReactNode;
}

export const AccessoryGrid = memo(({ title, children }: Props) => (
    <div className="vss-accessory__grid">
        <h2 className="vss-accessory__grid-title"><I18n messageId={title}/></h2>

        <div className="vss-accessory__grid-list">
            {children}
        </div>
    </div>
));
